<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Store</em>
				<span class="int_type_no_border mgr_10">
					<select v-model="selected_store_no" class="tbl_select">
						<option v-for="(store, index) in shopify_store_list" :key="index" :value="store.store_no">{{ store.store_name }}</option>
					</select>
				</span>
				<a href="javascript:void(0);" @click="getUnregisteredItemClassList()" class="gray_bt">Get Unregistered Item Class</a>
				<input v-if="false" ref="file_int" type="file" @change="fileUploadTest()" accept="image/*" />
				<a href="javascript:void(0);" @click="getExcelComparingAllProduct()" class="gray_bt">Test Item Class</a>
			</div>
		</div>
		<table class="list_tbl">
			<colgroup>
				<col style="width: 10%;" />
				<col style="width: 10%;" />
				<col style="width: 10%;" />
				<col style="width: 50%;" />
				<col style="width: 5%;" />
				<col style="width: 5%;" />
				<col style="width: 10%;" />
			</colgroup>
			<thead>
				<tr>
					<th>Class Group</th>
					<th>Class Code</th>
					<th>Class Name</th>
					<th>Description</th>
					<th>Closed</th>
					<th>Active</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(ic, index) in unregisterd_item_classes" :key="index">
					<td class="al_center">{{ ic.class_group_code }}</td>
					<td class="al_center">{{ ic.code }}</td>
					<td class="al_center">{{ ic.name }}</td>
					<td class="al_center">{{ ic.description }}</td>
					<td class="al_center">{{ ic.closed_yn }}</td>
					<td class="al_center">{{ ic.active_yn }}</td>
					<td class="al_center"><a href="javascript:void(0);" @click="productCreate(ic.code)" class="gray_bt">Register</a></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { apiGetShopifyStoreList, apiSetThirdPartyStoreSetting } from '@/api/shopify/shopify_common.js';
import { apiGetUnregisteredItemClassList, apiTransferItemClassToShopify, apiFileUploadTest, apiGetExcelComparingAllProduct } from '@/api/shopify/shopify_item.js';
import { apiDownloadFile } from '@/api/util.js';
export default {
	data: () => ({
		shopify_store_list: [],
		selected_store_no: null,

		unregisterd_item_classes: [],
	}),
	watch: {
		selected_store_no: {
			handler() {
				this.setThirdPartyStoreSetting();
			},
		},
	},
	methods: {
		async getExcelComparingAllProduct() {
			this.$toast.warning('Export to Excel takes time. Please be patient...', { duration: 10000 });

			const { data } = await apiGetExcelComparingAllProduct(this.selected_store_no);
			if (data.result !== 'SUCCESS') {
				this.$toast.error(data.msg);
				return;
			}

			const file_name = data.excel_file_name;
			if (file_name) await apiDownloadFile(file_name, 'VS_ShopifyProduct.xlsx');
		},

		async productCreate(class_code) {
			const { data } = await apiTransferItemClassToShopify(this.selected_store_no, class_code);
			if (data.result !== 'SUCCESS') this.$toast.error(data.msg);
			else this.getUnregisteredItemClassList();
		},
		async getUnregisteredItemClassList() {
			const { data } = await apiGetUnregisteredItemClassList(this.selected_store_no);
			this.unregisterd_item_classes = data.filter(d => d.code.indexOf('TEST') === 0);
		},
		// 사용보류
		async fileUploadTest() {
			const file_int = this.$refs.file_int;
			const file = file_int.files[0];

			if (!file) return;

			const formData = new FormData();
			formData.append('file', file);

			const { data } = await apiFileUploadTest(formData);
			if (data) console.log(JSON.stringify(data, null, 4));
		},
		async setThirdPartyStoreSetting() {
			const { data } = await apiSetThirdPartyStoreSetting(this.selected_store_no);
			if (data.result !== 'SUCCESS') {
				this.$toast.error('Network Error.');
			}
		},
		async getShopifyStoreList() {
			const { data } = await apiGetShopifyStoreList();
			this.shopify_store_list = data || [];
			if (this.shopify_store_list.length > 0) this.selected_store_no = this.shopify_store_list[0].store_no;
		},
	},
	created() {
		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_shopify_item');
		this.$store.commit('setSubTitle', 'Item -> Shopify');

		this.getShopifyStoreList();
	},
};
</script>

<style></style>
